import React, {Component} from 'react';
import GroupModalSelectForm from './GroupModalSelectForm'

class StationLinkGroupUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const {station, onUpdate} = this.props
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {GroupID, GroupName} = values
      const updateStation = {
        ...station,
        GroupID: GroupID,
        GroupName: GroupName
      }
      onUpdate(updateStation)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };

  render() {
    const {station, groups, treeGroups} = this.props
    const selectedGroup = {
      ID: station.GroupID
    }
    const title = `Cài đặt địa bàn cho trạm [${station.Name}]`
    return (<span>
      <a onClick={this.showModal}>Địa bàn</a>
      <GroupModalSelectForm title={title} group={selectedGroup} groups={groups} treeGroups={treeGroups} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default StationLinkGroupUpdate;



// WEBPACK FOOTER //
// ./src/components/StationLinkGroupUpdate.js